<script setup lang="ts">

import {computed} from "vue";

const props = defineProps({
  height: {
    type: Number,
    default: 41
  },
  color: {
    type: String,
    default: '#80BD1C'
  }
})

const height = computed(() => props.height)
const width = computed(() => props.height)
const color = computed(() => props.color)
</script>

<template>
  <svg
       x="0px" y="0px"
       :height="height" :width="width"
       xmlns="http://www.w3.org/2000/svg"
       viewBox="0 0 100.353 100.353">
    <g :fill=color>
      <path d="M89.381,19.52h-78.76c-3.983,0-7.224,3.241-7.224,7.224v4.828v10.404v31.281c0,3.983,3.241,7.223,7.224,7.223h78.76
		c3.983,0,7.223-3.24,7.223-7.223V41.976V31.572v-4.828C96.604,22.761,93.364,19.52,89.381,19.52z M6.396,26.744
		c0.001-2.33,1.895-4.224,4.224-4.224h78.76c2.329,0,4.223,1.895,4.223,4.224v3.328H6.396V26.744z M93.604,73.256
		c0,2.328-1.895,4.223-4.223,4.223h-78.76c-2.329,0-4.224-1.895-4.224-4.223V43.475h87.207V73.256z M93.604,40.475H6.397v-7.404
		h87.207V40.475z"/>
      <path d="M17.894,71.566c2.885,0,5.231-2.345,5.231-5.227c0-2.884-2.346-5.231-5.231-5.231c-2.883,0-5.229,2.347-5.229,5.231
		C12.665,69.221,15.011,71.566,17.894,71.566z M17.894,64.108c1.23,0,2.231,1.001,2.231,2.231c0,1.228-1.001,2.227-2.231,2.227
		c-1.229,0-2.229-0.999-2.229-2.227C15.665,65.109,16.665,64.108,17.894,64.108z"/>
      <path d="M29.08,68.015h42.264c0.829,0,1.5-0.671,1.5-1.5s-0.671-1.5-1.5-1.5H29.08c-0.829,0-1.5,0.671-1.5,1.5
		C27.58,67.344,28.251,68.015,29.08,68.015z"/>
    </g>
  </svg>
</template>

<style scoped lang="less">

</style>
